/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBookmarkCheckFill: {
  name: 'bookmark-check-fill';
  data: string;
} = {
  name: 'bookmark-check-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v15.674a2 2 0 0 0 2.55 1.923L12 20.04l5.45 1.557A2 2 0 0 0 20 19.674V4a2 2 0 0 0-2-2H6Zm9.707 6.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 11.586l3.293-3.293a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
